import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import React from 'react';
import {Checkbox} from '@deviceinsight/ng-ui-basic-components';
import RuleDeactivationWarning from './RuleDeactivationWarning';

type Props = {
	name: string;
	active: boolean;
	onNameChange: (arg0: string) => void;
	onActiveChange: (arg0: boolean) => void;
	canEdit: boolean;
	deactivatedBySystem: boolean;
};

const RuleNameAndActiveEdit = ({name, active, onNameChange, onActiveChange, canEdit, deactivatedBySystem}: Props) => {
	return (
		<div className="fields rule-edit-heading">
			<div className="field">
				<label>
					<Trans i18nKey="{ruleengine.edit.rule.name}">Name:</Trans>
				</label>
				<input
					type="text"
					value={name}
					onChange={(e) => onNameChange(e.target.value)}
					disabled={!canEdit}
					maxLength={255}
				/>
			</div>
			<div className="field">
				<label>
					<Trans i18nKey="ruleengine.edit.rule.active">Active:</Trans>
				</label>
				<div>
					<RuleDeactivationWarning deactivatedBySystem={deactivatedBySystem}></RuleDeactivationWarning>
					<Checkbox
						type="toggle"
						value={active}
						toggleSmall
						onChange={() => onActiveChange(!active)}
						disabled={!canEdit}
					/>
				</div>
			</div>
		</div>
	);
};

export default RuleNameAndActiveEdit;
